import axios from 'axios';
import { i18n } from 'next-i18next';
import Cookies from '~/services/Cookies';
import { locales } from '~/utils';
import config from '~/config';

export const addInterceptors = (axiosInstance) => {
  const transformLanguage = (payload = {}) => {
    if (payload.lang) {
      payload.lang = locales.convertToLongType(payload.lang);
    } else if (payload.language) {
      payload.language = locales.convertToLongType(payload.language);
    } else if (payload.disp_language) {
      payload.disp_language = locales.convertToLongType(payload.disp_language);
    }

    return payload;
  };

  const appendExtraData = (payload) => {
    if (!payload) return payload;
    if (!payload.service_type) payload.service_type = config.serviceType;
    // if (!payload.lang) payload.lang = config.language;
    // if (!payload.language) payload.language = config.language;
    if (!payload.lang) payload.lang = i18n?.language;
    if (!payload.language) payload.language = i18n?.language;
    if (!payload.disp_language) payload.disp_language = config.language;
    if (config.isChina()) {
      payload.china = true;
      payload.site = 2;
    } else {
      payload.overseas = true;
      payload.site = 1;
    }
    return payload;
  };

  /*
  - Each request will include following properties in query or body:
    + service_type
    + lang
    + language
    + disp_language
  - Each language param will be converted from "tw" to "zh-tw" and "cn" to "zh-cn".
  */
  axiosInstance.interceptors.request.use(
    (config) => {
      // console.log('---> Check config axios ---');
      // console.log(JSON.stringify(config));
      // if (config.timeout === 0) {
      //   config.timeout = 3000;
      // }
      if (!config.headers || !config.headers.Authorization) {
        const token = Cookies.get('token');
        if (token) {
          config.headers.common.Authorization = `${token}`;
          config.headers.Authorization = `${token}`;
        }
      }

      transformLanguage(config.params);
      transformLanguage(config.data);
      appendExtraData(config.params);
      appendExtraData(config.data);

      // if (process.browser) {
      // console.log('AXIOS REQUEST', config.method, config.url);
      // console.log('REQUEST PARAMS', config.params);
      // console.log('REQUEST DATA', config.data);
      // }
      return config;
    },
    (error) => Promise.reject(error.response),
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (process.browser && response && response.config) {
        console.log(
          'AXIOS RESPONSE',
          response.config.method,
          response.config.url,
        );
        console.log(response.status, response.data);
      }
      // Do something with response data
      if (response && response.data) {
        return response.data;
      }

      return response;
    },
    (error) => {
      if (error.config) {
        console.error(
          'AXIOS DEBUG ERROR',
          error.config.method,
          error.config.url,
        );
        if (error.response) {
          console.error(
            'AXIOS ERROR1111111',
            error.response.status,
            error.response.data,
          );
        } else {
          console.error(
            'AXIOS ERROR2222222',
            error.response.status,
            error.response.data,
          );
        }
      } else {
        console.log('AXIOS CUSTOM ERROR', error);
      }
      return Promise.reject(error);
    },
  );
};

addInterceptors(axios);

export default axios;
